module.exports = __webpack_public_path__ + "img/user-5.a4173041.jpg";